export const DISTRIBUTIONS = {
  BALANCED: 'BALANCED',
  LEAST_BUSY: 'LEAST_BUSY',
  RANDOM: 'RANDOM'
};